<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.ratePlanNav.overview')" link="ratePlans" />
    <item-nav-group v-if="!isEmpty(ratePlans)" :open="true" :label="$t('layout.nav.admin.ratePlanNav.ratePlans')">
      <template v-for="ratePlan in ratePlans" v-if="!ratePlan.deleted && ratePlan.type === 'DayRate'">
        <item-nav-group-item :label="getName(ratePlan.name, ratePlan.internalName)" :params="routeParams(ratePlan.id)" :key="ratePlan.id" link="ratePlan" />
        <template v-for="ratePlan1 in ratePlan.childRatePlans" v-if="!ratePlan1.deleted && ratePlan1.type === 'DayRate'">
          <item-nav-group-item :label="getName(ratePlan1.name, ratePlan1.internalName)"
                               :params="routeParams(ratePlan1.id)"
                               :key="ratePlan1.id"
                               :level="2"
                               link="ratePlan" />
          <template v-for="ratePlan2 in ratePlan1.childRatePlans" v-if="!ratePlan2.deleted && ratePlan2.type === 'DayRate'">
            <item-nav-group-item :label="getName(ratePlan2.name, ratePlan2.internalName)"
                                 :params="routeParams(ratePlan2.id)"
                                 :key="ratePlan2.id"
                                 :level="3"
                                 link="ratePlan" />
            <template v-for="ratePlan3 in ratePlan2.childRatePlans" v-if="!ratePlan3.deleted && ratePlan3.type === 'DayRate'">
              <item-nav-group-item :label="getName(ratePlan3.name, ratePlan3.internalName)"
                                   :params="routeParams(ratePlan3.id)"
                                   :key="ratePlan3.id"
                                   :level="4"
                                   link="ratePlan" />
            </template>
          </template>
        </template>
      </template>
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(ratePlans) && hasLicense('Packages')" :open="true" :label="$t('layout.nav.admin.ratePlanNav.packages')">
      <template v-for="ratePlan in ratePlans" v-if="!ratePlan.deleted && ratePlan.type === 'Package'">
        <item-nav-group-item :label="getName(ratePlan.name, ratePlan.internalName)" :params="routeParams(ratePlan.id)" :key="ratePlan.id" link="ratePlan" />
        <template v-for="ratePlan1 in ratePlan.childRatePlans" v-if="!ratePlan1.deleted && ratePlan1.type === 'Package'">
          <item-nav-group-item :label="getName(ratePlan1.name, ratePlan1.internalName)"
                               :params="routeParams(ratePlan1.id)"
                               :key="ratePlan1.id"
                               :level="2"
                               link="ratePlan" />
          <template v-for="ratePlan2 in ratePlan1.childRatePlans" v-if="!ratePlan2.deleted && ratePlan2.type === 'Package'">
            <item-nav-group-item :label="getName(ratePlan2.name, ratePlan2.internalName)"
                                 :params="routeParams(ratePlan2.id)"
                                 :key="ratePlan2.id"
                                 :level="3"
                                 link="ratePlan" />
            <template v-for="ratePlan3 in ratePlan2.childRatePlans" v-if="!ratePlan3.deleted && ratePlan3.type === 'Package'">
              <item-nav-group-item :label="getName(ratePlan3.name, ratePlan3.internalName)"
                                   :params="routeParams(ratePlan3.id)"
                                   :key="ratePlan3.id"
                                   :level="4"
                                   link="ratePlan" />
            </template>
          </template>
        </template>
      </template>
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(deletedRatePlans)" :open="false" :label="$t('layout.nav.admin.ratePlanNav.deletedRatePlans')">
      <item-nav-group-item v-for="ratePlan in deletedRatePlans"
                           :label="getName(ratePlan.name, ratePlan.internalName)"
                           :params="routeParams(ratePlan.id)"
                           :key="ratePlan.id"
                           link="ratePlan" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'RatePlanNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      ratePlans: [],
    };
  },

  computed: {
    deletedRatePlans: function () {
      return this.ratePlans.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateRatePlans();

    this.$serviceBus.$on('ratePlan.list', (data) => {
      if (isNil(data)) {
        this.updateRatePlans();
      } else {
        this.ratePlans = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateRatePlans() {
      this.axios.get(this.serviceUrls.ratePlan.list(this))
        .then((response) => {
          let ratePlans = response.data.data;

          ratePlans = sortBy(ratePlans, (it) => {
            if (it.deleted === true) return 3;
            else if (it.type === 'DayRate') return 1;
            else return 2;
          }, ['sort', `name.${this.hotelSettings.details.primaryLanguage}`]);

          const parentRatePlans = ratePlans.filter(it => !it.deleted && it.ratePlanMode !== 'Derived');
          const deletedRatePlans = ratePlans.filter(it => it.deleted);
          const targetRatePlans = parentRatePlans.concat(deletedRatePlans);

          const childRatePlans = ratePlans.filter(it => !it.deleted && it.ratePlanMode === 'Derived');
          const ratePlanIdMap = keyBy(targetRatePlans, 'id');

          for (let i = 0; !isEmpty(childRatePlans) && i < 5; i++) {
            childRatePlans.forEach((item, index, object) => {
              if (!isNil(item.parentRatePlanId) && !isNil(ratePlanIdMap[item.parentRatePlanId])) {
                const parentRatePlan = ratePlanIdMap[item.parentRatePlanId];
                if (isNil(parentRatePlan.childRatePlans)) {
                  parentRatePlan.childRatePlans = [];
                }
                parentRatePlan.childRatePlans.push(item);
                ratePlanIdMap[item.id] = item;
                object.splice(index, 1);
              }
            });
          }

          ratePlans.forEach((ratePlan) => {
            if (!isNil(ratePlan) && !isNil(ratePlan.childRatePlans)) {
              ratePlan.childRatePlans = sortBy(ratePlan.childRatePlans, ['sort', obj => obj.name[this.hotelSettings.details.primaryLanguage]]);
            }
          });

          this.ratePlans = targetRatePlans;
        });
    },
    getName(name, internalName = null) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isNil(internalName)) {
        const langInternalName = internalName[this.$shortLocale] || internalName[this.hotelSettings.details.primaryLanguage];
        if (!isEmpty(langInternalName)) {
          ret += ` [${langInternalName}]`;
        }
      }

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(ratePlanId) {
      return {
        ratePlanId: ratePlanId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/RatePlanNav.vue